import script from "./CreateBatch.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateBatch.vue?vue&type=script&setup=true&lang=js"

import "./CreateBatch.vue?vue&type=style&index=0&id=63fe3c8e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63fe3c8e"]])

export default __exports__